/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorArticleSlider from 'base/components/labrador/ArticleSlider';

export const DynamicLabradorArticleSlider: typeof LabradorArticleSlider = (props) => {
    return <ErrorBoundary><LabradorArticleSlider {...props} /></ErrorBoundary>;
}
export type DynamicLabradorArticleSliderProps = PropsFromComponent<typeof LabradorArticleSlider>;
